import { createTheme } from '@mui/material';
import { ptBR as ptBrGrid } from '@mui/x-data-grid/locales';
import { ptBR } from '@mui/x-date-pickers/locales';

export const theme = createTheme(
  {
    typography: {
      fontFamily: ['Inter', 'Roboto Slab', 'Arial', 'sans-serif'].join(','),
      h1: {
        fontFamily: ['Roboto Slab', 'Arial', 'sans-serif'].join(','),
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '64px',
        lineHeight: '72px',
        letterSpacing: '-0.03em',
        background: 'linear-gradient(90deg, #118BD7 0%, #75B21D 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        display: 'inline-block',
      },
      h2: {
        fontFamily: ['Roboto Slab', 'Arial', 'sans-serif'].join(','),
        fontStyle: 'normal',
        fontSize: '40px',
        lineHeight: '40px',
        letterSpacing: '-0.03em',
        fontWeight: 300,
        color: '#5cc2aa',
      },
      h3: {
        fontSize: '30px',
        lineHeight: '38px',
        fontStyle: 'normal',
        fontWeight: 600,
        color: '#3cb99c',
      },
      h4: {
        fontSize: '24px',
        lineHeight: '32px',
        fontStyle: 'normal',
        fontWeight: 600,
        color: '#0d47a1',
      },
      h5: {
        fontSize: '18px',
        lineHeight: '28px',
        fontStyle: 'normal',
        fontWeight: 600,
        color: '#0d47a1',
      },
      h6: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '32px',
        color: '#1565c0',
      },
      subtitle1: {
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#0d47a1',
      },
      subtitle2: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '24px',
        color: '#1565c0',
      },
      body1: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        color: '#757575',
      },
      body2: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '18px',
        color: '#757575',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {},
      },
      MuiInputBase: {
        styleOverrides: {
          root: {},
        },
      },
    },
  },
  ptBR,
  ptBrGrid,
);